export default __webpack_public_path__ + "static/media/trash.46632f4d.svg";